import styled, { css } from 'styled-components';

/** The empty slot at the foot of the content panel, sized by whatever a page puts in it. */
export const FooterSlot = styled.div`
  flex: 0 0 auto;
`;

/**
 * Docked, the bar spans the panel under its scrolling area with the page's own
 * gutter, so its contents line up with the page's. Undocked, it takes its place
 * in the flow.
 */
export const FooterBar = styled.div<{ $docked: boolean }>`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.background.canvas};

  ${({ theme, $docked }) =>
    $docked
      ? css`
          padding: ${theme.spacing(1.5, 2)};

          ${theme.breakpoints.up('sm')} {
            padding: ${theme.spacing(2, 4)};
          }
        `
      : css`
          margin-top: ${theme.spacing(3)};
          padding-top: ${theme.spacing(2)};
        `}
`;

export const FooterContent = styled.div<{ $maxWidth?: number }>`
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
  margin-inline: auto;
`;
